var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 10,
    viewBox: "0 0 254 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L250 5.025",
    stroke: "url(#paint0_linear_916_24)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_24",
    x1: 3.98132,
    y1: 8.49996,
    x2: 249.981,
    y2: 9.52496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4FD7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientRec);
export default __webpack_public_path__ + "static/media/gradientRec.b4fe0f5faf54de3df1075097f2e4e84c.svg";
export { ForwardRef as ReactComponent };